import React, { useState } from 'react'

import { CreateForm, CreateToolbar, AsidePreview } from '../containers'

export const CreateQuiz = (props: any) => {
  const {
    showAside = false,
    shouldRedirect = true,
    closeDrawer = false,
    onSubmitSuccess = () => {},
    onSubmitFailure = () => {},
  } = props

  const [formData, setFormData] = useState([])

  return (
    <>
      <CreateForm
        {...props}
        formTitle="Adicionar Nova Checklist"
        setFormData={setFormData}
        toolbar={<CreateToolbar closeDrawer={closeDrawer} />}
        aside={showAside ? <AsidePreview formData={formData} /> : <></>}
        onSuccess={onSubmitSuccess}
        onFailure={onSubmitFailure}
        shouldRedirect={shouldRedirect}
        resource="cms/grouper/quiz"
      />
    </>
  )
}
